/** @format */

import React from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import {FormContextProvider} from '../contexts/FormContext'
import {AllFormsContextProvider} from '../contexts/AllFormsContext'
import {ProjectsContextProvider} from '../contexts/ProjectsContext'
import {FullPageLoading} from '../components/Loading'

const FormPage = React.lazy(() => import('../forms/FormPage'))
const Admin = React.lazy(() => import('../Admin'))

const IFrameRouter = () => {
  return (
    <React.Suspense fallback={<FullPageLoading />}>
      <Switch>
        <Route path="/iframe/forms/:hashid" component={FormPageWrapper} />
        <Route exact path="/admin" component={Admin} />
      </Switch>
    </React.Suspense>
  )
}

function FormPageWrapper({match, ...rest}) {
  const hashid = match.params.hashid

  return (
    <FormContextProvider hashid={hashid}>
      <FormPage {...rest} />
    </FormContextProvider>
  )
}

export default function() {
  return (
    <AllFormsContextProvider>
      <ProjectsContextProvider>
        <IFrameRouter />
      </ProjectsContextProvider>
    </AllFormsContextProvider>
  )
}
